<template>
  <div class="student" v-if="enabled">
    <router-view></router-view>
    <div class="countdown" ref="countdown" v-show="countdown">
      <h1>{{count}}</h1>
    </div>
    <div class="name-wrap" v-if="namecard">
      <div class="card">
        <h2>请输入你的名字</h2>
        <div class="name">
          <input name="name" v-model="name" placeholder="请输入你的名字">
        </div>
        <button class="btn" @click="intoRoom">进入房间</button>
      </div>
    </div>
    <div class="answer-wrap" v-if="answer">
      <div class="a-tip">
        <h1>随堂问卷</h1>
        <p>问卷：{{question}}</p>
        <pre class="question-content" v-html="codeFixed"></pre>
        <div class="code-wrap">
          <!-- <code-panel ref="codepanel"></code-panel> -->
        </div>
        <button @click="selectYes">Yes</button>
        <button @click="selectNo">No</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getUrlParam,
    generateUUID
  } from '@/common/js/utils'
  import CodePanel from '@/components/CodePanel'
  export default {
    components: {
      CodePanel
    },
    data() {
      return {
        roomId: this.$route.params.roomId,
        languageId: this.$route.params.languageId,
        countdown: false,
        count: 3,
        namecard: false,
        name: '',
        answer: false,
        question: '',
        code: '',
        enabled: true
      }
    },
    computed: {
      // editer() {
      //   return this.$refs.codepanel.editer
      // }
      codeFixed() {
        return this.code.replace(/\n/g, '<br/>').replace(/ /g, '&nbsp;')
      }
    },
    created() {
      var name = getUrlParam('name')
      // this.editer.setOption('readOnly', true)
      if (!name) {
        this.namecard = true
      }
    },
    mounted() {
      let _this = this
      this.socket.on('start.live', () => {
        _this.countdown = true
        _this.isLive = true
        // 倒计时
        var countdown = setInterval(() => {
          console.log(_this.count)
          _this.count--
          if (_this.count === -1) {
            _this.countdown = false
            clearInterval(countdown)
            _this.count = 3
          }
        }, 1000)
      })
      this.socket.on('class.questionnaire', (data) => {
        this.answer = true
        this.question = data.question
        this.code = data.code
        console.log(data)
      })
      // gxb入口进来的学生
      let userInfo = {
        uuid: generateUUID(),
        roomId: this.roomId,
        role: 'student'
      }
      this.socket.emit('join.room', userInfo)
      this.socket.on('error', (err) => {
        if (!err.uuid || err.uuid === userInfo.uuid) {
          _this.enabled = false
          _this.$error(err.msg)
        }
      })
    },
    methods: {
      intoRoom() {
        let languageId = this.languageId
        console.log(typeof languageId)
        if (!languageId) {
          this.$router.push({
            name: 'WebStudent',
            params: {
              roomId: this.roomId
            },
            query: {
              name: this.name
            }
          })
        } else {
          this.$router.push({
            name: 'Play',
            params: {
              roomId: this.roomId,
              languageId: languageId,
              name: this.name
            },
            query: {
              name: this.name
            }
          })
        }
        this.namecard = false
      },
      selectYes() {
        this.socket.emit('class.questionnaire.yes')
        this.answer = false
      },
      selectNo() {
        this.socket.emit('class.questionnaire.no')
        this.answer = false
      },
      lockRoom() {}
    }
  }

</script>

<style lang="scss">
  .student {
    .name-wrap {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 999;

      .card {
        background-color: #fff;
        width: 300px;
        min-height: 200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
      }
      h2 {
        font-size: 18px;
        font-weight: normal;
        color: #1FB6FF;
        padding: 12px;
        border-bottom: 1px solid #999;
      }
      .name {
        margin: 32px 0;
        input {
          width: 240px;
          height: 28px;
        }
      }
      button {
        background-color: #1FB6FF;
        color: #fff;
      }
    }
    .answer-wrap {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 999;

      .a-tip {
        width: 420px;
        min-height: 100px;
        padding: 12px;
        background: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        border-radius: 4px;
        h1 {
          font-size: 18px;
          border-bottom: 1px solid #eee;
          padding-bottom: 4px;
          margin-bottom: 4px;
        }
        p {
          text-align: left;
        }
        .code-wrap {
          text-align: left;
          margin-bottom: 10px;
        }
        pre {
          text-align: left;
          background: #f5f8f8;
          padding: 6px 10px;
          overflow: auto;
          margin-top: 5px;
          max-height: 300px;
        }
        button {
          padding: 7px 36px;
          border-radius: 4px;
          background: #1FB6FF;
          border: none;
          color: #fff;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// student.vue?1ba0fdd9